// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createPinCrossReference} from '../../shared/repositories';

export const createPinCrossReferenceReport = postArgs =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await createPinCrossReference(postArgs);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_PIN_CROSS_REFERENCE_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/action-creators/report.js